<div class="w-full grid grid-cols-4 gap-2 items-center">
  <div class="col-span-3">
    <mat-form-field class="w-full">
      <mat-label>Bank Account</mat-label>
      <mat-select [formControl]="formControl" [required]="field.props.required">
        @for (option of this.props?.options; track option?.value) {
          <mat-option [value]="option?.value">
            {{option?.label}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <button mat-button class="w-full cta-main flex justify-center items-center" (click)="addNewBankAccount()">
    <div class="hidden sm:flex md:hidden xl:flex justify-center items-center">
      <mat-icon class="text-white mr-0 lg:text-md xl:text-base">add</mat-icon>
      <span class="lg:text-sm xl:text-md">Add Account</span>
    </div>
    <mat-icon class="block sm:hidden md:block xl:hidden text-white mr-0">account_balance</mat-icon>
  </button>
</div>
